.root {
    position: relative;
}

.border {
    border: 1px solid var(--border-color);
    border-radius: 4px;
}

.root:hover > .border {
    border-color: var(--border-color-hover);
}

.root:focus-within > .border {
    border-width: 2px;
    border-color: var(--color-primary);
}

.rootError > .border {
    border-width: 1px;
    border-color: var(--color-error) !important;
}

.root div[contentEditable=true] {
    outline: none;
    min-height: 128px;
    padding: 12px;
}

.root div[contentEditable=true] span {
    background-color: #00000014;
    padding: 4px;
    border-radius: 8px;
}

.root p {
    margin: 0;
    padding: 0;
}

.toolbar {
    border-top: 1px solid var(--border-color);
    padding: 8px;
    display: flex;
    column-gap: 8px;
}

.toolbar > div {
    height: 24px;
    border-radius: 8px;
    padding: 8px;
}